module.exports = __webpack_public_path__ + "static/media/coding.a708ea9f.jpg";